import React from 'react'

export default class LoadingScreenComponent extends React.Component {

    render () {
        return (
            <div className="loading-screen" style={ { 'height': this.props.height + 'px' }}>
                <div className="sk-fading-circle loading-icon">
                    <div className="sk-circle1 sk-circle"></div>
                    <div className="sk-circle2 sk-circle"></div>
                    <div className="sk-circle3 sk-circle"></div>
                    <div className="sk-circle4 sk-circle"></div>
                    <div className="sk-circle5 sk-circle"></div>
                    <div className="sk-circle6 sk-circle"></div>
                    <div className="sk-circle7 sk-circle"></div>
                    <div className="sk-circle8 sk-circle"></div>
                    <div className="sk-circle9 sk-circle"></div>
                    <div className="sk-circle10 sk-circle"></div>
                    <div className="sk-circle11 sk-circle"></div>
                    <div className="sk-circle12 sk-circle"></div>
                </div>
                <p>
                    { this.props.text }
                </p>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/LoadingScreenComponent.jsx